export default __webpack_public_path__ + "static/media/l3.cb4d1065.jpg";